var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClass},[(_vm.isCheckoutFlow)?_c('Header'):_vm._e(),_c('Login',{attrs:{"flow":_vm.flow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }